import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { computed, observable } from 'mobx';
import { useEffect } from 'react';
import { jumpPage } from '@src/utils/common-util';
import { useMount } from 'ahooks';

class FourthPageStore {
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  @observable showOtherMecha = false;

  @observable swiperActionIndex = 0;

  // 0:初始进入 1：页面离开 3: 机甲轮播模块滚动触发
  @observable pageShowState = 2;

  @observable
  layerData = {
    mecha_list: []
  };

  @observable
  localData = {
    /**
     * 机兵详情跳转按钮
     */
    mecha_detail_btn: require('./images/fourth-page-layer-23.png'),
    /**
     * 机兵列表跳转按钮
     */
    mecha_list_btn: require('./images/fourth-page-layer-24.png')
  };

  // 当前机甲形态切换类型
  @observable isOtherMechaType = false;

  @computed
  get currentMecha() {
    return this.layerData.mecha_list[this.mechaSwiper.activeIndex] || {};
  }

  mechaSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      effect: 'fade',
      autoplay: false
    }
  });

  versionTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: false,
      slidesPerView: 3,
      centeredSlides: true
    },
    onSlideChange: () => {
      this.pageShowState = 2;
    }
  });

  versionTabSwiperActIndex = 0;

  playInAnimate = () => {
    this.pageShowState = 0;
  };

  leaveInAnimate = () => {
    this.pageShowState = 1;
  };

  setVersionSwiperIndex = event => {
    event.persist();
    const { nativeEvent } = event || {};
    const activeIndex = Number(nativeEvent?.target?.dataset?.index);
    const swiperActiveIndex = this.versionTabSwiper.activeIndex;

    const normalChange = () => {
      if (activeIndex > swiperActiveIndex) {
        this.versionTabSwiper.goNext();
      } else if (activeIndex < swiperActiveIndex) {
        this.versionTabSwiper.goPrev();
      }
    };

    if (swiperActiveIndex === 0 && activeIndex === this.layerData.mecha_list.length - 1) {
      this.versionTabSwiper.goPrev();
    } else if (swiperActiveIndex === this.layerData.mecha_list.length - 1 && activeIndex === 0) {
      this.versionTabSwiper.goNext();
    } else {
      normalChange();
    }
  };

  toDetail = mecha_id => {
    // 6月9号前屏蔽入口
    // Toast.info('敬请期待');
    // return false;

    if (!IS_DEV_ENV) {
      const url = 'mecha.html';
      jumpPage(url, `#/?mecha_id=${mecha_id}`);
    } else {
      this.mainStore?.redirect(`/mecha?mecha_id=${mecha_id}`);
    }
  };

  toMechaList() {
    if (!IS_DEV_ENV) {
      const url = 'mecha-list.html';
      jumpPage(url, '#/');
    } else {
      this.mainStore?.redirect('/mecha-list');
    }
  }

  initLoadMecha() {
    setTimeout(() => {
      const domList = document.querySelectorAll('.mecha-img');
      domList.forEach(element => {
        const src = element.dataset.src || '';
        element.src = src;
      });
    }, 2000);
  }

  use() {
    const Part4Date = useLayerData('part4');

    useMount(() => {
      this.initLoadMecha();
    });

    useEffect(
      () => {
        const otherMechaDomList = document.querySelectorAll('.mecha-swiper-box  [data-other-src]');
        if (otherMechaDomList) {
          otherMechaDomList.forEach(elm => {
            const { src, otherSrc } = elm?.dataset;
            if (!this.isOtherMechaType) {
              elm.src = src;
            } else {
              elm.src = otherSrc;
            }
          });
        }
      },
      [this.isOtherMechaType]
    );

    useEffect(
      () => {
        this.isOtherMechaType = false;
        this.swiperActionIndex = this.mechaSwiper.activeIndex;
      },
      [this.mechaSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.isOtherMechaType = false;
        this.swiperActionIndex = this.versionTabSwiper.activeIndex;
      },
      [this.versionTabSwiper.activeIndex]
    );

    useEffect(
      () => {
        this.mechaSwiper.activeIndex = this.swiperActionIndex;
        this.versionTabSwiper.activeIndex = this.swiperActionIndex;
      },
      [this.swiperActionIndex]
    );

    useEffect(
      () => {
        if (Part4Date) {
          const { mecha_list = [], page_config = {} } = Part4Date || {};
          // const { mecha_list = [], page_config = {} } = mockData || Part4Date || {};
          this.layerData.mecha_list = mecha_list;
          this.layerData.page_config = page_config;
        }
      },
      [Part4Date]
    );
  }
}
export default FourthPageStore;
